import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import EditMyRemuModal from "./editProfileModals/EditMyRemuModal";
import { remunerationBands , currencyList } from '../../appConstants'

function MyRemu(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);

    const [ newPlanModal, setNewPlanModal ] = useState(false);
    const toggleNewPlanModal = () => setNewPlanModal(!newPlanModal);

    var { profile } = props.store
    var { remuneration } = profile
    var { currency , band } = remuneration
    return (
        <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>Current Remuneration</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" >                        
                        <li><i className="far fa-edit" onClick={toggleNewPlanModal}></i></li>   
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                        <EditMyRemuModal modal={newPlanModal} toggle={toggleNewPlanModal} remuneration={remuneration} />
                    </ul>
                </div>
            </div>
            <Collapse isOpen={!collapse}>            
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                <div className="mg-b-15">
                    <div className="wd-pct-20 mg-r-15 " >{(band !== 0 ? currencyList[currency].label : "")  + " " + remunerationBands[band].label}</div>
                </div> 
            </div>
            </Collapse>
    </div>
    </div>
        
    );
  }

export default MyRemu